import { IndexQuotesDataTypes, IndexQuotesSocketDataTypes } from './types';

import axiosInstance from 'services/common/instance';

export const getIndexQuotesSocketService = async (): Promise<IndexQuotesSocketDataTypes[]> => {
  const response = await axiosInstance.get('index-quotes/websocket');
  return response.data.data;
};

export const getIndexQuotesService = async (): Promise<IndexQuotesDataTypes[]> => {
  const response = await axiosInstance.get('index-quotes');
  return response.data.data;
};
